import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Search } from '../../../../components/Icon';
import { changeVehicleFilter, updateSearchString } from '../../actions';
import ReactGA from "react-ga4"; // ✅ import GA wrapper

import styles from './SearchText.module.css';

const STATE = {
  search: '',
};

class VehicleSearchTextComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
      search: props.filter.searchString || '',
      isSearchExecuted: false,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.search !== this.state.search) {
      this.props.updateSearchString(this.state.search);
    }
  }

  reset() {
    this.setState({ ...STATE });
  }

  doSearch = (trigger = 'button') => {
    const searchTerm = this.state.search;

    ReactGA.event("vehicle_search", {
      search_term: searchTerm,
      trigger: trigger,
    });

    if (this.props.weblogin) {
      this.props.filterVehicles(this.props.filter);
    } else {
      this.props.setSearchString(searchTerm);
    }
  };

  handleKeyPress = event => {
    if (event.key === 'Enter') {
      this.doSearch('enter');
    }
  };

  render() {
    return (
      <div className="d-flex">
        <input
          type="text"
          className={`form-control fw-light ${styles.Input}`}
          name="search"
          value={this.state.search}
          placeholder={`${this.lblStr('zoeken')}...`}
          onChange={evt => this.setState({ search: evt.target.value })}
          onKeyPress={this.handleKeyPress}
        />
        <button
          className={`btn btn-outline-secondary ${styles.Button}`}
          type="button"
          onClick={() => this.doSearch('button')}
        >
          <Search />
        </button>
      </div>
    );
  }
}

VehicleSearchTextComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = createStructuredSelector({
  //filter: selectVehicleFilter(),
});

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    setSearchString(string) {
      dispatch(changeVehicleFilter('searchString', string));
    },
    updateSearchString(searchString) {
      dispatch(updateSearchString(searchString));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleSearchText = compose(
  withConnect,
  withRouter,
  injectIntl
)(VehicleSearchTextComp);
